/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DatePeriodValueEnum {
    AllTime,
    SingleDay,
    Period,
}
